import React from 'react';
import { Check } from 'lucide-react';

function SubmitButton({ loading, onClick }) {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className="absolute bottom-8 right-4 w-16 h-16 bg-brand-primary text-white rounded-full shadow-2xl hover:bg-brand-primary/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center border-4 border-white"
      style={{ zIndex: 1000 }}
      aria-label="Completar entrega"
    >
      {loading ? (
        <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin" />
      ) : (
        <Check className="w-8 h-8" strokeWidth={3} />
      )}
    </button>
  );
}

export default SubmitButton;